const BYTES_IN_KB = 1024;
const KB_IN_MB = 1024;

const mbToBytes = (megabytes) => megabytes * KB_IN_MB * BYTES_IN_KB;

export default mbToBytes;
